import moment from 'moment';
import { ACITONCOPYRIGHT } from '../../../actionTypes';
import { merge, get, clone, set, findIndex } from 'lodash';
export function getTopicList(payload, callback, errorCallback) {
	return {
		type: ACITONCOPYRIGHT.FETCH_COPYRIGHT_TOPICLIST,
		payload,
		callback,
		errorCallback
	};
}
export function getSportList(payload, callback, errorCallback) {
	return {
		type: ACITONCOPYRIGHT.FETCH_COPYRIGHT_SPORTLIST,
		payload,
		callback,
		errorCallback
	};
}
export function getTopicConfigList(payload, callback, errorCallback) {
	return {
		type: ACITONCOPYRIGHT.FETCH_TOPICCONFIG_LIST,
		payload,
		callback,
		errorCallback
	};
}
export function getBannerConfigList(payload, callback, errorCallback) {
	return {
		type: ACITONCOPYRIGHT.FETCH_BANNERCONFIG_LIST,
		payload,
		callback,
		errorCallback
	};
}
export function getActivityConfigList(payload, callback, errorCallback) {
	return {
		type: ACITONCOPYRIGHT.FETCH_ACTIVITYCONFIG_LIST,
		payload,
		callback,
		errorCallback
	};
}
export function getPlacardItemList(payload, callback, errorCallback) {
	return {
		type: ACITONCOPYRIGHT.FETCH_PLACARDITEM_LIST,
		payload,
		callback,
		errorCallback
	};
}
export function setGalleryImgPraise(payload, callback, errorCallback) {
	return {
		type: ACITONCOPYRIGHT.FETCH_GALLERYIMG_PRAISE,
		payload,
		callback,
		errorCallback
	};
}
export function setNewsPraise(payload, callback, errorCallback) {
	return {
		type: ACITONCOPYRIGHT.FETCH_COPYRIGHT_NEWSPRAISE_HOME,
		payload,
		callback,
		errorCallback
	};
}
export function setCancelNewsPraise(payload, callback, errorCallback) {
	return {
		type: ACITONCOPYRIGHT.FETCH_COPYRIGHT_CANCELNEWSPRAISE_HOME,
		payload,
		callback,
		errorCallback
	};
}
export function handleImgData(imgList = []) {
	//	imgList.forEach(item => {
	//		if (this.ids.findIndex(id=>{return item.placardSeq==id})>-1) {
	//			item.isSetUp = true;
	//		} else {
	//			item.isSetUp = false;
	//		}
	//	});
	let topList = imgList.filter(item => {
		return item.isSetUp;
	});
	let list = imgList.filter(item => {
		return !item.isSetUp;
	});
	let arr = topList.concat(list);
	let array = [];
	for (let i = 0, j = arr.length; i < j; i++) {
		let item = arr[i];
		let mutil = false;
		if (get(item, 'topicContentResponses.length', 0) > 1) {
			mutil = true;
		}
		if (!get(item, 'topicContentResponses', '')) {
			continue;
		}
		let newsType = item.newsType;
		let placardItem = {};
		if (item.topicContentResponses && item.topicContentResponses.length > 0) {
			placardItem = item.topicContentResponses.find(t => t.isCover) || item.topicContentResponses[0];
		}
		let {
			id,
			newsId,
			key,
			thumbVideoUrl,
			thumbKey,
			width,
			height,
			size,
			description,
			section,
			addTime,
			contentId,
			sectionId,
			originalUrl,
			darkOriginalUrl,
			midUrl,
			type,
			sectionDescription,
			topicName,
			workUrl,
			avatar,
			nickname,
			likeStatus,
			endorseCount
		} = placardItem;
		array.push({
			id: newsType===1?id:newsId,
			newsType,
			mutil,
			url: newsType===1?key:workUrl,
			sectionDescription: newsType===1?sectionDescription:topicName,
			thumbKey,
			smallUrl: newsType===1?thumbKey:workUrl,
			thumbVideoUrl,
			width: width,
			height: height,
			size,
			section, //description || '##',
			sectionId,
			date: moment(addTime).format('YYYY-MM-DD') || moment(new Date()).format('YYYY-MM-DD'),
			descHeight: (124 * 2) / 75, // 57,
			contentId,
			description,
			originalUrl,
			darkOriginalUrl,
			midUrl,
			avatar,
			nickname,
			likeStatus,
			endorseCount,
			type
		});
	}
	return {
		columns: 2,
		columnWidth: 360 / 75, //165,
		gutter: 10 / 75, //5px
		items: array
	};
}
export function handleIndexData(imgList, index) {
	let array = [];
	let items = imgList[index].topicContentResponses || [];
	let group_description = imgList[index].description;
	for (let i = 0, j = items.length; i < j; i++) {
		let {
			id,
			topicId,
			sectionId,
			likeStatus,
			thumbVideoUrl,
			key,
			thumbKey,
			width,
			height,
			size,
			midUrl,
			sectionDescription,
			description,
			section,
			addTime,
			contentId,
			originalUrl,
			darkOriginalUrl,
			avatar,
			nickname,
			endorseCount,
			isCover,
			type
		} = items[i];
		array.push({
			id,
			topicId,
			sectionId,
			likeStatus,
			thumbVideoUrl,
			url: key,
			smallUrl: thumbKey,
			width: width,
			height: height,
			size,
			//title: description, //description || '##',
			date: moment(addTime).format('YYYY-MM-DD') || moment(new Date()).format('YYYY-MM-DD'),
			descHeight: (124 * 2) / 75, // 57,
			contentId,
			section,
			description,
			intro: sectionDescription,
			sectionDescription,
			group_description,
			originalUrl,
			darkOriginalUrl,
			midUrl,
			avatar,
			nickname,
			endorseCount,
			isCover,
			type
		});
	}
	return {
		columns: 2,
		columnWidth: 330 / 75, //165,
		gutter: 10 / 75, //5px
		items: array
	};
}
